const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:4545/api'

function getApiOrigin(): string {
  return API_URL.replace(/\/api\/?$/, '').replace(/\/$/, '')
}

/**
 * Публичный URL файла из Laravel storage (диск public, symlink /storage).
 * Строим от origin API (VITE_API_URL), т.к. APP_URL на бэкенде может быть без порта.
 */
export function storagePublicUrl(pathOrUrl: string | null | undefined): string {
  if (!pathOrUrl) return ''

  if (pathOrUrl.startsWith('http://') || pathOrUrl.startsWith('https://')) {
    try {
      const parsed = new URL(pathOrUrl)
      if (parsed.pathname.startsWith('/storage/')) {
        return `${getApiOrigin()}${parsed.pathname}`
      }
    } catch {
      return pathOrUrl
    }
    return pathOrUrl
  }

  const path = pathOrUrl.replace(/^\/+/, '').replace(/^storage\//, '')
  return `${getApiOrigin()}/storage/${path}`
}
